export default __webpack_public_path__ + "static/media/menu-item.46507837.jpg";